import { type Route } from '!/router'
import { keys } from '@/jail'
import { Footer } from '@/ui/components/Footer'
import { NoContentBlock } from '@/ui/components/NoContentBlock'
import { AccountSettingsModal } from '~/features/portal/redirect'
import { NavBar } from '~/widgets/NavBar'
import {
  AuthorizePaymentForm,
  ExternalPaymentOpen,
  GravyPaymentForm,
  NoPaymentForm,
} from '~/widgets/Payment'
import {
  AnnouncementPopup,
  PinLockPopup,
  ProfilesCreatePopup,
  ProfilesRemovePopup,
} from '~/widgets/Popups'
import { SignInToWatchPopup } from '~/widgets/SignInToWatch'
import * as root from './root'

export default {
  keys: [keys.app, keys.guest],

  children: [
    {
      path: '',
      component: [
        NavBar,
        root.HomePage,
        GravyPaymentForm,
        AuthorizePaymentForm,
        NoPaymentForm,
        ExternalPaymentOpen,
        PinLockPopup,
        NoContentBlock,
        Footer,
        SignInToWatchPopup,
        ProfilesRemovePopup,
        ProfilesCreatePopup,
        AnnouncementPopup,
        AccountSettingsModal,
      ],
      // skin: root.skin,
      init: root.model.init,
      left: root.model.left,
    },
  ],
} satisfies Route
